import { useContext, useState } from "react";
import { Accordion, Col, Container, Row } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";
import { useTranslation } from "react-i18next";
import { AiOutlinePlus } from "react-icons/ai";
import { BiMinus } from "react-icons/bi";

type Props = {};

const SiteSolutionIndustryComponent = (props: Props) => {
  const { t } = useTranslation();
  const [selectImageIndex, setSelectImageIndex] = useState<number>(0);

  const solutionImagesUrl: string[] = [
    "https://cdn.1cdn.app/application/LOUISEBOT/23072609465926_Financial.jpg",
    "https://cdn.1cdn.app/application/LOUISEBOT/23072609430156_Digital_health.jpg",
    "https://cdn.1cdn.app/application/LOUISEBOT/23072609491642_Marketplace.jpg",
    "https://cdn.1cdn.app/application/LOUISEBOT/23072609500215_On_demand_service.jpg",
    "https://cdn.1cdn.app/application/LOUISEBOT/23072609504758_Retail.jpg",
    "https://cdn.1cdn.app/application/LOUISEBOT/23072609512315_Social.jpg"
  ];

  function ContextAwareToggle({
    eventKey,
    callback,
    children
  }: {
    eventKey: string;
    callback?: any;
    children?: any;
  }) {
    const { activeEventKey } = useContext(AccordionContext);

    const decoratedOnClick = useAccordionButton(eventKey, () => {
      setSelectImageIndex(+eventKey);
      return callback && callback(eventKey);
    });

    const isCurrentEventKey = activeEventKey === eventKey;

    return (
      <>
        {!isCurrentEventKey && (
          <div
            onClick={decoratedOnClick}
            className="d-flex justify-content-between align-items-center w-100 cursor-pointer"
          >
            {children}
            <AiOutlinePlus className="cursor-pointer tw-text-neutral-400" />
          </div>
        )}
        {isCurrentEventKey && (
          <div
            onClick={decoratedOnClick}
            className="d-flex justify-content-between align-items-center w-100 cursor-pointer"
          >
            {children}
            <BiMinus
              className="cursor-pointer tw-text-neutral-400"
              onClick={decoratedOnClick}
            />
          </div>
        )}
      </>
    );
  }

  return (
    <section className="solution-industry bg-secondColor">
      <Container fluid={"xl"}>
        <Row className="mt-5">
          <Col className="my-4">
            <Row>
              <Col className="d-flex justify-content-center text-center">
                <h1 className="font-sofiaSans fw-bold">
                  {t("home/SiteSolutionIndustry/title")}
                </h1>
              </Col>
            </Row>
            <Row className="mt-3 p-lg-2">
              <Col lg="7" md="7" className="d-none d-md-block">
                <Row className="h-100 align-items-center">
                  <Col className="rounded position-relative">
                    <img
                      loading="lazy"
                      crossOrigin="anonymous"
                      src={solutionImagesUrl[selectImageIndex]}
                      className="w-100"
                    />
                  </Col>
                </Row>
              </Col>
              <Col lg="5" md="5" sm="12" className="px-lg-5">
                <Accordion defaultActiveKey="0" className="px-3 bg-secondColor">
                  <Accordion.Item
                    eventKey="0"
                    className="border-0 border-bottom bg-secondColor"
                  >
                    <div className="accordion-header">
                      <ContextAwareToggle eventKey="0">
                        <span className="font-poppins fw-bold">
                          {t("home/SiteSolutionIndustry/q-01")}
                        </span>
                      </ContextAwareToggle>
                    </div>

                    <Accordion.Body>
                      <Row className="d-md-none">
                        <Col>
                          <img
                            crossOrigin="anonymous"
                            src={solutionImagesUrl[0]}
                            className="w-100"
                          />
                        </Col>
                      </Row>
                      <Row className="tw-mt-5 md:tw-mt-0">
                        <Col>
                          <p className="tw-text-zinc-500">
                            {t("home/SiteSolutionIndustry/text-01")}
                          </p>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="1"
                    className="border-0 border-bottom bg-secondColor"
                  >
                    <div className="accordion-header">
                      <ContextAwareToggle eventKey="1">
                        <span className="font-poppins fw-bold">
                          {t("home/SiteSolutionIndustry/q-02")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body>
                      <Row className="d-md-none">
                        <Col>
                          <img
                            crossOrigin="anonymous"
                            src={solutionImagesUrl[1]}
                            className="w-100"
                          />
                        </Col>
                      </Row>
                      <Row className="tw-mt-5 md:tw-mt-0">
                        <Col>
                          <p className="tw-text-zinc-500">
                            {t("home/SiteSolutionIndustry/text-02")}
                          </p>
                          <p className="tw-text-zinc-500">
                            {t("home/SiteSolutionIndustry/text-03")}
                          </p>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="2"
                    className="border-0 border-bottom bg-secondColor"
                  >
                    <div className="accordion-header">
                      <ContextAwareToggle eventKey="2">
                        <span className="font-poppins fw-bold">
                          {t("home/SiteSolutionIndustry/q-03")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body>
                      <Row className="d-md-none">
                        <Col>
                          <img
                            crossOrigin="anonymous"
                            src={solutionImagesUrl[2]}
                            className="w-100"
                          />
                        </Col>
                      </Row>
                      <Row className="tw-mt-5 md:tw-mt-0">
                        <Col>
                          <p className="tw-text-zinc-500">
                            {t("home/SiteSolutionIndustry/text-04")}
                          </p>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="3"
                    className="border-0 border-bottom bg-secondColor"
                  >
                    <div className="accordion-header">
                      <ContextAwareToggle eventKey="3">
                        <span className="font-poppins fw-bold">
                          {t("home/SiteSolutionIndustry/q-04")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body>
                      <Row className="d-md-none">
                        <Col>
                          <img
                            crossOrigin="anonymous"
                            src={solutionImagesUrl[3]}
                            className="w-100"
                          />
                        </Col>
                      </Row>
                      <Row className="tw-mt-5 md:tw-mt-0">
                        <Col>
                          <p>{t("home/SiteSolutionIndustry/text-05")}</p>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="4"
                    className="border-0 border-bottom bg-secondColor"
                  >
                    <div className="accordion-header">
                      <ContextAwareToggle eventKey="4">
                        <span className="font-poppins fw-bold">
                          {t("home/SiteSolutionIndustry/q-05")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body>
                      <Row className="d-md-none">
                        <Col>
                          <img
                            crossOrigin="anonymous"
                            src={solutionImagesUrl[4]}
                            className="w-100"
                          />
                        </Col>
                      </Row>
                      <Row className="tw-mt-5 md:tw-mt-0">
                        <Col>
                          <p className="tw-text-zinc-500">
                            {t("home/SiteSolutionIndustry/text-06")}
                          </p>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item
                    eventKey="5"
                    className="border-0 border-bottom bg-secondColor"
                  >
                    <div className="accordion-header">
                      <ContextAwareToggle eventKey="5">
                        <span className="font-poppins fw-bold">
                          {t("home/SiteSolutionIndustry/q-06")}
                        </span>
                      </ContextAwareToggle>
                    </div>
                    <Accordion.Body>
                      <Row className="d-md-none">
                        <Col>
                          <img
                            crossOrigin="anonymous"
                            src={solutionImagesUrl[5]}
                            className="w-100"
                          />
                        </Col>
                      </Row>
                      <Row className="tw-mt-5 md:tw-mt-0">
                        <Col>
                          <p className="tw-text-zinc-500">
                            {t("home/SiteSolutionIndustry/text-07")}
                          </p>
                        </Col>
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SiteSolutionIndustryComponent;
